<template>
	<div id="legal">
		<div class="inner" v-html="touDetail[localeCode]"></div>
	</div>
</template>

<script>
export default {
	name: 'TermsOfUse',
	data() {
		return {
			touDetail: [],
		};
	},
	created() {
		this.$http.get(`${this.cdnHost}/frontend/v2/${environment.region}/tou/detail.json`).then((response) => {
			this.touDetail = response.data;
		});
	},
};
</script>
